/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Input } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { PermissionData } from 'Store/manage-permission/types'
import { selectPermissionActionEvent } from 'Store/manage-permission/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { getDefaultStatus } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { DefaultStatus, RoleMerchantType } from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import { DetailDrawer } from 'Components/common/MainLayout'
import { roleListAPI } from 'Store/manage-role/api'
import { RoleListReq } from 'Store/manage-role/types'
import { selectRoleList } from 'Store/manage-role/selector'
import { selectRoleListEvent } from 'Store/manage-role/selector'
import { RolePackageInfo } from 'Store/manage-role-package/types'

type Props = {
  visible: boolean
  onCloseDrawer: () => void
  onSelect: (id: number) => void
  currentSelected: RolePackageInfo[]
} & ReduxProps

const SelectRoles: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, visible, onCloseDrawer, onSelect, currentSelected } = props
  const dispatch = useDispatch()

  const [filter, setFilter] = useState({
    order_by: 'id',
    sort: 'asc',
    status: '',
    keyword: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 100,
  })
  const datas = list.data || []

  const onGetList = (): void => {
    const req: RoleListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      name: filter.keyword,
      merchant_type: RoleMerchantType.POS,
      status: filter.status,
      order_by: 'id',
      sort: filter.sort || 'asc',
    }
    dispatch(roleListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onClickSearch = () => {
    onGetList()
  }

  useEffect(() => {
    onGetList()
  }, [filter?.order_by, filter?.sort])

  useEffect(() => {
    if (visible) {
      onGetList()
    }
  }, [visible])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const renderStatus = (status: DefaultStatus) => (
    <StatusTag isPass={status === DefaultStatus.ACTIVE} text={getDefaultStatus(status)} />
  )

  const renderSelectButton = (id: number, record: PermissionData) => {
    const isSelected = currentSelected && currentSelected.find(item => item.role_id === id)
    return (
      <ActionButton
        text=""
        icon={<PlusOutlined />}
        label="เพิ่ม"
        action="add"
        onClick={() => onSelect(record.id)}
        disabled={!!isSelected}
      />
    )
  }

  const columns = [
    {
      title: '',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      render: renderSelectButton,
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: true,
      width: '60px',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      //  render: renderCompanyInfo,
      sorter: true,
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description',
    //   key: 'description',
    //   sorter: true,
    // },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
      sorter: true,
    },
  ]

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="middle" gutter={[8, 8]}>
        <Col xs={24} md={24}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={12}>
              <SearchInput
                name="path"
                placeholder="ชื่อ ​Roles"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </Col>
      </Row>
    </FilterWrapper>
  )

  return (
    <DetailDrawer
      title={'เลือก Role'}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={null}
      width={'60%'}
      maskClosable={true}
    >
      {FilterContent}
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={listEvent.IsLoading}
        paginationContent={null}
        onSort={onSort}
        scrollX={500}
        size="small"
      />
    </DetailDrawer>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectRoleList(state),
    listEvent: selectRoleListEvent(state),
    event: selectPermissionActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

export default connect(mapStateToProps)(SelectRoles)
